import React, { useEffect } from "react";
import "./About.css";
import AOS from "aos";
import "aos/dist/aos.css";

// Hardcoded member data
const members = [
  {
    _id: 1,
    name: "RK Ramesh - Founder & Managing trustee",
    description: "RK Ramesh is the founder of Our Country Our People Foundation, a charitable trust dedicated to serving and supporting senior citizens. With a deep sense of social responsibility and compassion towards the elderly, he established this foundation with the vision of providing a safe, caring, and dignified life for aged people who need love, care, and support in their later years. RK Ramesh strongly believes that elders are the backbone of our society and deserve respect, comfort, and emotional well-being. Through Our Country Our People Foundation, he aims to create a nurturing environment where senior citizens feel valued, protected, and cared for like family. The old age home focuses not only on shelter and basic needs but also on emotional support, healthcare assistance, and a peaceful living atmosphere. Driven by humanity, kindness, and service, RK Ramesh continues to work towards building a society where no elder feels abandoned or neglected. His mission is to ensure that every senior citizen under the care of the foundation lives with dignity, happiness, and hope.",
    phoneNumber: "+91 9840693733",
    imageURL: "/Sir.png", // put your images in public/members/
  },
 
  
];

const sidebarLinks = [
  { name: "What We Do In Future", path: "/ourprojects" },
  { name: "Memories", path: "/gallery" },
  { name: "Get Involved", path: "/donate" },
  { name: "Touch Us", path: "/contact" },
];

export default function About() {
  useEffect(() => {
    // Initialize AOS animations
    AOS.init({
      duration: 1000,
      easing: "ease-in-out-cubic",
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <>
      <p className="breadcrumb" data-aos="fade-right">
        Home &nbsp;›&nbsp; Our Projects
      </p>

      <div className="team-page">
        <aside className="sidebar">
          <ul>
            {sidebarLinks.map((item, index) => (
              <li
                key={index}
                data-aos="fade-right"
                data-aos-delay={index * 150}
              >
                <a href={item.path}>{item.name}</a>
              </li>
            ))}
          </ul>
        </aside>

        <div className="content">
          <img
            src="/open.jpg"
            alt="Event"
            className="top-image"
            data-aos="zoom-in"
          />

          <h2 className="section-title2" data-aos="fade-up">
            What is our goal in the long run?
          </h2>

          <p className="paragraph" data-aos="fade-up">
            Our long-term vision is to create strong, self-reliant communities
            where every individual has the opportunity to learn, grow, and lead a
            dignified life. Through our initiatives, we aim to bring meaningful
            change that uplifts families and strengthens local development.
          </p>

          {members.map((member, index) => (
            <div
              className="member-card"
              key={member._id}
              data-aos="fade-up"
              data-aos-delay={200 + index * 150}
            >
              {member.imageURL && (
                <img
                  src={member.imageURL}
                  alt={member.name}
                  className="member-img"
                  loading="lazy"
                />
              )}

              <div className="member-info">
                <h3 className="member-name">{member.name}</h3>
                <p className="member-text">{member.description}</p>
                <p className="member-phone">📞 {member.phoneNumber}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
